<template>
  <section>
    <div class="achievementList">
      <div class="mapDetailListSr">
        <template v-if="list.length > 0">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="mapDetalItem"
            @click="onToCrmDetail(item.order_code)"
          >
            <div class="mapDetalItemR">
              <p class="p1">
                <span class="spl">{{ item.order_code }}</span>
                <span class="spr">￥{{ item.amount }}</span>
              </p>
              <p class="p3">
                <span>{{ item.distributorname }}</span>
                <span>{{ item.create_date }}</span>
              </p>
            </div>
          </div>
          <div v-if="loadEnd">
            <p class="pt15 pb15 laodEndText">没有更多内容啦~</p>
          </div>
        </template>
        <template v-else>
          <div class="tc">
            <img width="80%" src="./assets/img/emptyData.png" />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
import BetterScroll from "better-scroll";

export default {
  name: "test",
  data() {
    return {
      list: [],
      listparam: {
        department_id: "",
        begin_date: "",
        end_date: "",
        page: 1,
        page_size: 20
      },
      bs: null,
      disSrool: false,
      loadEnd: false,
      loading: false
    };
  },
  components: {},
  async mounted() {
    await this.getListData();
    setTimeout(() => {
      this.bs = new BetterScroll(".achievementList", {
        scrollY: true,
        pullUpLoad: true,
        click: true,
        mouseWheel: true
      });
      this.bs.on("scroll", async pos => {
        let top = this.bs.scrollerHeight + pos.y - this.bs.wrapper.offsetHeight;
        if (top < 90 && !this.disSrool && !this.loading) {
          this.listparam.page = this.listparam.page + 1;
          await this.getListData();
          this.bs.refresh();
        }
      });
    }, 100);
  },
  methods: {
    onToCrmDetail(id) {
      // location.href = 'http://localhost:9010/#/orderInfoDetail?id=' + id;
      location.href = "/jlbwx/index.html#/orderInfoDetail?id=" + id;
    },
    getListData() {
      return new Promise(resolve => {
        this.loading = true;
        this.$common
          .http({
            mt: "post",
            url: "/wxapi/sale/list_by_department",
            data: this.listparam
          })
          .then(res => {
            this.loading = false;
            this.list = this.list.concat(res.data.data.items);
            if (res.data.data.items.length < this.listparam.page_size) {
              this.disSrool = true;
              this.loadEnd = true;
            } else {
              this.disSrool = false;
              this.loadEnd = false;
            }
            resolve(res);
          });
      });
    }
  },
  created() {
    this.listparam.department_id = this.$route.query.department_id;
    this.listparam.begin_date = this.$route.query.begin_date;
    this.listparam.end_date = this.$route.query.end_date;
    this.listparam.order_status = this.$route.query.order_status;
  }
};
</script>
<style lang="less" scope>
.achievementList {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  .mapDetalItem {
    margin-top: 10px;
    background-color: #fff;
    padding: 10px 15px;
    .mapDetalItemR {
      display: inline-block;
      width: 100%;
      .p1 {
        padding: 5px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .spl {
        }
        .spr {
          color: #ea5412;
        }
      }
      .p3 {
        font-size: 13px;
        color: #7f7f7f;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .laodEndText {
    color: #969799;
    font-size: 14px;
    text-align: center;
  }
}
</style>
